<template>
  <div class="rb-ob-form rb-match-page rb-session-page">
    <header>
      <h1 class="rb-ob-title">{{ confirmedHeld ? $t('intake.onlineSession.endTitle') : (lang === 'fa' ? 'از صفحهٔ جلسه خارج شدی' : 'You left the session page') }}</h1>
    </header>

    <div class="rb-session-outcome">
      <p>{{ confirmedHeld ? $t('intake.onlineSession.endBody') : (lang === 'fa' ? 'خروج از این صفحه به معنی پایان یا ثبت برگزاری جلسه نیست. وضعیت جلسه از سامانه دریافت می‌شود.' : 'Leaving this page does not end the session or record attendance. Session status is loaded from the service.') }}</p>
      <p v-if="error" role="alert">{{ error }}</p>
    </div>

    <ul class="rb-session-meta" :aria-label="$t('intake.onlineSession.endMetaAria')">
      <li>
        <span class="rb-session-meta-k">{{ $t('intake.onlineSession.endStatus') }}</span>
        <span class="rb-session-meta-v">{{ statusLabel }}</span>
      </li>
      <li>
        <span class="rb-session-meta-k">{{ $t('intake.onlineSession.endFeedback') }}</span>
        <span class="rb-session-meta-v">{{ feedbackLabel }}</span>
      </li>
      <li v-if="sessionTime">
        <span class="rb-session-meta-k">{{ $t('intake.onlineSession.waitTime') }}</span>
        <span class="rb-session-meta-v">{{ sessionTime }}</span>
      </li>
    </ul>

    <div class="rb-ob-actions">
      <button v-if="feedbackAvailable" class="rb-ob-submit" type="button" @click="feedback">
        {{ $t('intake.onlineSession.endFeedbackCta') }}
      </button>
      <div class="rb-session-action-row">
        <button class="rb-ob-submit rb-ob-submit-secondary" type="button" @click="dashboard">
          {{ $t('intake.onlineSession.endDashboard') }}
        </button>
        <button class="rb-ob-submit rb-ob-submit-secondary" type="button" @click="bookNext">
          {{ $t('intake.onlineSession.endBookNext') }}
        </button>
      </div>
      <p class="rb-ob-status" role="status" aria-live="polite"></p>
      <div class="rb-ob-trust">
        <p>{{ $t('intake.trustPath') }}</p>
        <p>{{ $t('authUi.familyNote') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {formatSessionListTitle, fetchOwnedSession, fetchPendingTreatmentAssessments, sessionStatusLabel, reserveSessionRoute} from '@/intake/portalApi'
import {clientError} from '@/intake/clientMessages'
export default {
  name:'SessionEndStep',data(){return{session:null,error:'',feedbackAvailable:false}},computed:{
    lang(){return this.$route.params.lang||'fa'},
    confirmedHeld(){return !!this.session && ['used','done','completed'].includes(String(this.session.state||'').toLowerCase())},
    statusLabel(){return this.session?sessionStatusLabel(this.session,this.lang):'—'},
    feedbackLabel(){return this.$t('intake.onlineSession.endFeedbackSrs')},
    sessionTime(){return formatSessionListTitle(this.session,this.lang)},
  },
  mounted(){const id=String(this.$route.query.id||'');return Promise.all([fetchOwnedSession(id),fetchPendingTreatmentAssessments().catch(()=>[])]).then(([session,pending])=>{this.session=session;this.feedbackAvailable=pending.some(row=>String(row.sessionId)===id && ['SRS','CSRS'].includes(row.instrument))}).catch(e=>{this.error=clientError(e,this.lang)})},
  methods:{
    feedback(){const sessionId=(this.session&&this.session.id)||this.$route.query.id;this.$router.push({name:'intakeOutcomeSrs',params:{lang:this.lang},query:sessionId?{sessionId:String(sessionId)}:{}})},
    dashboard(){this.$router.push({name:'portalHome',params:{lang:this.lang}})},
    bookNext(){this.$router.push(reserveSessionRoute(this.lang))},
  },
}
</script>
